
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./summary.css";

function SummaryPage() {
  const matchId = localStorage.getItem("match_id");
  const navigate = useNavigate();

  const [matchSummary, setMatchSummary] = useState(null);
  const [totalOvers, setTotalOvers] = useState("0.0"); // ✅ total overs
  const [extras, setExtras] = useState(null);
  const [topBatsmen, setTopBatsmen] = useState([]);
  const [topBowlers, setTopBowlers] = useState([]);

  useEffect(() => {
    // Fetch match summary (total runs & wickets)
    fetch(`https://nammateam.onrender.com/match/summary/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setMatchSummary(data); })
      .catch(err => console.error("Error fetching match summary:", err));

    // Fetch extras
    fetch(`https://nammateam.onrender.com/match/extras/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setExtras(data.extras); })
      .catch(err => console.error("Error fetching extras:", err));

    // Fetch batting stats
    fetch(`https://nammateam.onrender.com/battinstats/${matchId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.batsmen)) {
          const sortedBatsmen = data.batsmen.sort(
            (a, b) => b.runs - a.runs || a.balls_faced - b.balls_faced
          );
          setTopBatsmen(sortedBatsmen.slice(0, 3));
        }
      })
      .catch(err => console.error("Error fetching batting stats:", err));

    // Fetch bowling stats
    fetch(`https://nammateam.onrender.com/bowlingstats/${matchId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.bowlers)) {
          // Calculate total balls bowled for overall overs
          const totalBalls = data.bowlers.reduce((sum, b) => sum + b.balls_bowled, 0);
          setTotalOvers(`${Math.floor(totalBalls / 6)}.${totalBalls % 6}`);

          // Top 3 bowlers
          const sortedBowlers = data.bowlers
            .sort((a, b) => b.wickets - a.wickets || a.runs_given - b.runs_given)
            .slice(0, 3)
            .map(b => ({
              ...b,
              overs: `${Math.floor(b.balls_bowled / 6)}.${b.balls_bowled % 6}`
            }));
          setTopBowlers(sortedBowlers);
        }
      })
      .catch(err => console.error("Error fetching bowling stats:", err));
  }, [matchId]);

  return (
    <div className="summary-container">
      {/* Header */}
      <div className="os-header">
        <button className="os-back-btn" onClick={() => navigate("/live")}>
          ← Back
        </button>
        <h2>Match Summary</h2>
      </div>

      {/* Match Summary */}
      {matchSummary && (
        <div className="summary-section" style={{ marginTop: "60px" }}>
          <h3 className="summary-title">Overall</h3>
          <div className="summary-stats-row">
            <div className="summary-stat-card">
              <span className="stat-label">Total Runs</span>
              <span className="stat-value">{matchSummary.total_runs}</span>
            </div>
            <div className="summary-stat-card">
              <span className="stat-label">Wickets</span>
              <span className="stat-value">{matchSummary.total_wickets}</span>
            </div>
            <div className="summary-stat-card">
              <span className="stat-label">Overs</span>
              <span className="stat-value">{totalOvers}</span>
            </div>
          </div>
        </div>
      )}

      {/* Top Batsmen */}
      <div className="summary-section">
        <h3 className="summary-title">Top Batsmen</h3>
        <ul className="summary-list">
          {topBatsmen.map((b, idx) => (
            <li key={idx} className="summary-item">
              <span className="summary-name">{b.batsman_name}</span>
              <span className="summary-stats">{b.runs} ({b.balls_faced})</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Top Bowlers */}
      <div className="summary-section">
        <h3 className="summary-title">Top Bowlers</h3>
        <ul className="summary-list">
          {topBowlers.map((b, idx) => (
            <li key={idx} className="summary-item">
              <span className="summary-name">{b.bowler_name}</span>
              <span className="summary-stats">{b.wickets}-{b.runs_given} <span>({b.overs})</span></span>
            </li>
          ))}
        </ul>
      </div>

      {/* Extras Summary */}
      {extras && (
        <div className="summary-section">
          <h3 className="summary-title">Extras</h3>
          <div className="extras-grid">
            <div className="extras-card">
              <span className="extras-label">Wides</span>
              <span className="extras-value">{extras.wides}</span>
            </div>
            <div className="extras-card">
              <span className="extras-label">No Balls</span>
              <span className="extras-value">{extras.no_balls}</span>
            </div>
            <div className="extras-card">
              <span className="extras-label">Byes</span>
              <span className="extras-value">{extras.byes}</span>
            </div>
            <div className="extras-card">
              <span className="extras-label">Leg Byes</span>
              <span className="extras-value">{extras.leg_byes}</span>
            </div>
            <div className="extras-card total-extras">
              <span className="extras-label">Total Extras</span>
              <span className="extras-value">{extras.total}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SummaryPage;
